import { getSessionFromStorage } from '@consigli/oauth';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { captureError } from '@/monitoring';

import { ErrorPage } from './error-page';

/**
 * The router's `errorElement`. Exists only to supply `useRouteError()`, which
 * works nowhere else — the provider-stack boundary renders `ErrorPage` directly.
 *
 * The report here is usually a duplicate the dedupe drops: the window handler
 * sees the same error first (see `monitoring/README.md`). Kept because it is
 * correct if that ordering ever changes, and the dedupe makes it free.
 */
export const RouteErrorPage = () => {
  const error: unknown = useRouteError();

  useEffect(() => {
    captureError(error, { source: 'route-error-element', route: window.location.pathname });
  }, [error]);

  // This is the errorElement for `/auth` and `/logout` too, where there is no
  // session and so no bearer token to submit feedback with.
  return <ErrorPage error={error} canSendFeedback={getSessionFromStorage() != null} />;
};
